import { getFaIcon } from '@odin-labs/components';

import { faCcAmex } from '@fortawesome/free-brands-svg-icons/faCcAmex';
import { faCcDinersClub } from '@fortawesome/free-brands-svg-icons/faCcDinersClub';
import { faCcDiscover } from '@fortawesome/free-brands-svg-icons/faCcDiscover';
import { faCcJcb } from '@fortawesome/free-brands-svg-icons/faCcJcb';
import { faCcMastercard } from '@fortawesome/free-brands-svg-icons/faCcMastercard';
import { faCcVisa } from '@fortawesome/free-brands-svg-icons/faCcVisa';

import { faQuestion } from '@fortawesome/pro-light-svg-icons/faQuestion';
import { faArrowFromLeft } from '@fortawesome/pro-light-svg-icons/faArrowFromLeft';
import { faArrowFromRight } from '@fortawesome/pro-light-svg-icons/faArrowFromRight';
import { faArrowLeft } from '@fortawesome/pro-light-svg-icons/faArrowLeft';
import { faArrowRight } from '@fortawesome/pro-light-svg-icons/faArrowRight';
import { faArrowRotateLeft } from '@fortawesome/pro-light-svg-icons/faArrowRotateLeft';
import { faArrowToBottom } from '@fortawesome/pro-light-svg-icons/faArrowToBottom';
import { faArrowToLeft } from '@fortawesome/pro-light-svg-icons/faArrowToLeft';
import { faArrowToRight } from '@fortawesome/pro-light-svg-icons/faArrowToRight';
import { faArrowRightToLine } from '@fortawesome/pro-light-svg-icons/faArrowRightToLine';
import { faArrowLeftFromLine } from '@fortawesome/pro-light-svg-icons/faArrowLeftFromLine';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare';
import { faBarcodeRead } from '@fortawesome/pro-light-svg-icons/faBarcodeRead';
import { faBars } from '@fortawesome/pro-light-svg-icons/faBars';
import { faBriefcase } from '@fortawesome/pro-light-svg-icons/faBriefcase';
import { faBuilding } from '@fortawesome/pro-light-svg-icons/faBuilding';
import { faBuildingColumns } from '@fortawesome/pro-light-svg-icons/faBuildingColumns';
import { faBullhorn } from '@fortawesome/pro-light-svg-icons/faBullhorn';
import { faBusinessTime } from '@fortawesome/pro-light-svg-icons/faBusinessTime';
import { faCalendar } from '@fortawesome/pro-light-svg-icons/faCalendar';
import { faCalendarCheck } from '@fortawesome/pro-light-svg-icons/faCalendarCheck';
import { faCalendarDay } from '@fortawesome/pro-light-svg-icons/faCalendarDay';
import { faCalendarDays } from '@fortawesome/pro-light-svg-icons/faCalendarDays';
import { faCalendarXmark } from '@fortawesome/pro-light-svg-icons/faCalendarXmark';
import { faCctv } from '@fortawesome/pro-light-svg-icons/faCctv';
import { faChartPie } from '@fortawesome/pro-light-svg-icons/faChartPie';
import { faChartSimple } from '@fortawesome/pro-light-svg-icons/faChartSimple';
import { faChevronLeft } from '@fortawesome/pro-light-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { faClipboardCheck } from '@fortawesome/pro-light-svg-icons/faClipboardCheck';
import { faClock } from '@fortawesome/pro-light-svg-icons/faClock';
import { faCog } from '@fortawesome/pro-light-svg-icons/faCog';
import { faCommentAltPlus } from '@fortawesome/pro-light-svg-icons/faCommentAltPlus';
import { faCommentMedical } from '@fortawesome/pro-light-svg-icons/faCommentMedical';
import { faCompass } from '@fortawesome/pro-light-svg-icons/faCompass';
import { faConstruction } from '@fortawesome/pro-light-svg-icons/faConstruction';
import { faCopy } from '@fortawesome/pro-light-svg-icons/faCopy';
import { faCreditCard } from '@fortawesome/pro-light-svg-icons/faCreditCard';
import { faCreditCardFront } from '@fortawesome/pro-light-svg-icons/faCreditCardFront';
import { faDatabase } from '@fortawesome/pro-light-svg-icons/faDatabase';
import { faDebug } from '@fortawesome/pro-light-svg-icons/faDebug';
import { faDoorOpen } from '@fortawesome/pro-light-svg-icons/faDoorOpen';
import { faDrone } from '@fortawesome/pro-light-svg-icons/faDrone';
import { faDownload } from '@fortawesome/pro-light-svg-icons/faDownload';
import { faEnvelope } from '@fortawesome/pro-light-svg-icons/faEnvelope';
import { faEdit } from '@fortawesome/pro-light-svg-icons/faEdit';
import { faExclamationCircle } from '@fortawesome/pro-light-svg-icons/faExclamationCircle';
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons/faExclamationTriangle';
import { faExpand } from '@fortawesome/pro-light-svg-icons/faExpand';
import { faObjectGroup } from '@fortawesome/pro-light-svg-icons/faObjectGroup';
import { faEye } from '@fortawesome/pro-light-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/pro-light-svg-icons/faEyeSlash';
import { faFileAlt } from '@fortawesome/pro-light-svg-icons/faFileAlt';
import { faFileCode } from '@fortawesome/pro-light-svg-icons/faFileCode';
import { faFileChartLine } from '@fortawesome/pro-light-svg-icons/faFileChartLine';
import { faFileExcel } from '@fortawesome/pro-light-svg-icons/faFileExcel';
import { faFileExport } from '@fortawesome/pro-light-svg-icons/faFileExport';
import { faFileInvoiceDollar } from '@fortawesome/pro-light-svg-icons/faFileInvoiceDollar';
import { faFilePdf } from '@fortawesome/pro-light-svg-icons/faFilePdf';
import { faFilePlus } from '@fortawesome/pro-light-svg-icons/faFilePlus';
import { faFileSignature } from '@fortawesome/pro-light-svg-icons/faFileSignature';
import { faFileVideo } from '@fortawesome/pro-light-svg-icons/faFileVideo';
import { faForward } from '@fortawesome/pro-light-svg-icons/faForward';
import { faGaugeHigh } from '@fortawesome/pro-light-svg-icons/faGaugeHigh';
import { faGlobe } from '@fortawesome/pro-light-svg-icons/faGlobe';
import { faGrid2 } from '@fortawesome/pro-light-svg-icons/faGrid2';
import { faHandsHoldingChild } from '@fortawesome/pro-light-svg-icons/faHandsHoldingChild';
import { faHardHat } from '@fortawesome/pro-light-svg-icons/faHardHat';
import { faHelmetSafety } from '@fortawesome/pro-light-svg-icons/faHelmetSafety';
import { faHistory } from '@fortawesome/pro-light-svg-icons/faHistory';
import { faHourglassClock } from '@fortawesome/pro-light-svg-icons/faHourglassClock';
import { faIdBadge } from '@fortawesome/pro-light-svg-icons/faIdBadge';
import { faIdCard } from '@fortawesome/pro-light-svg-icons/faIdCard';
import { faIdCardClip } from '@fortawesome/pro-light-svg-icons/faIdCardClip';
import { faInbox } from '@fortawesome/pro-light-svg-icons/faInbox';
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons/faInfoCircle';
import { faKey } from '@fortawesome/pro-light-svg-icons/faKey';
import { faLandmark } from '@fortawesome/pro-light-svg-icons/faLandmark';
import { faLanguage } from '@fortawesome/pro-light-svg-icons/faLanguage';
import { faLightbulbOn } from '@fortawesome/pro-light-svg-icons/faLightbulbOn';
import { faLink } from '@fortawesome/pro-light-svg-icons/faLink';
import { faListUl } from '@fortawesome/pro-light-svg-icons/faListUl';
import { faLock } from '@fortawesome/pro-light-svg-icons/faLock';
import { faLockKeyhole } from '@fortawesome/pro-light-svg-icons/faLockKeyhole';
import { faMagic } from '@fortawesome/pro-light-svg-icons/faMagic';
import { faMagnet } from '@fortawesome/pro-light-svg-icons/faMagnet';
import { faMagnifyingGlass } from '@fortawesome/pro-light-svg-icons/faMagnifyingGlass';
import { faMapLocationDot } from '@fortawesome/pro-light-svg-icons/faMapLocationDot';
import { faMapMarkerAlt } from '@fortawesome/pro-light-svg-icons/faMapMarkerAlt';
import { faMemo } from '@fortawesome/pro-light-svg-icons/faMemo';
import { faMinusOctagon } from '@fortawesome/pro-light-svg-icons/faMinusOctagon';
import { faMobile } from '@fortawesome/pro-light-svg-icons/faMobile';
import { faMobileSignal } from '@fortawesome/pro-light-svg-icons/faMobileSignal';
import { faNewspaper } from '@fortawesome/pro-light-svg-icons/faNewspaper';
import { faPause } from '@fortawesome/pro-light-svg-icons/faPause';
import { faPen } from '@fortawesome/pro-light-svg-icons/faPen';
import { faPencil } from '@fortawesome/pro-light-svg-icons/faPencil';
import { faPhone } from '@fortawesome/pro-light-svg-icons/faPhone';
import { faPlay } from '@fortawesome/pro-light-svg-icons/faPlay';
import { faPlus } from '@fortawesome/pro-light-svg-icons/faPlus';
import { faPrint } from '@fortawesome/pro-light-svg-icons/faPrint';
import { faQrcode } from '@fortawesome/pro-light-svg-icons/faQrcode';
import { faRedo } from '@fortawesome/pro-light-svg-icons/faRedo';
import { faRows } from '@fortawesome/pro-light-svg-icons/faRows';
import { faSave } from '@fortawesome/pro-light-svg-icons/faSave';
import { faSearch } from '@fortawesome/pro-light-svg-icons/faSearch';
import { faSend } from '@fortawesome/pro-light-svg-icons/faSend';
import { faShieldCheck } from '@fortawesome/pro-light-svg-icons/faShieldCheck';
import { faSignature } from '@fortawesome/pro-light-svg-icons/faSignature';
import { faSitemap } from '@fortawesome/pro-light-svg-icons/faSitemap';
import { faStethoscope } from '@fortawesome/pro-light-svg-icons/faStethoscope';
import { faSync } from '@fortawesome/pro-light-svg-icons/faSync';
import { faTable } from '@fortawesome/pro-light-svg-icons/faTable';
import { faTicket } from '@fortawesome/pro-light-svg-icons/faTicket';
import { faTimer } from '@fortawesome/pro-light-svg-icons/faTimer';
import { faTimes } from '@fortawesome/pro-light-svg-icons/faTimes';
import { faTools } from '@fortawesome/pro-light-svg-icons/faTools';
import { faTrash } from '@fortawesome/pro-light-svg-icons/faTrash';
import { faTrashAlt } from '@fortawesome/pro-light-svg-icons/faTrashAlt';
import { faToolbox } from '@fortawesome/pro-light-svg-icons/faToolbox';
import { faTruck } from '@fortawesome/pro-light-svg-icons/faTruck';
import { faTurnDownLeft } from '@fortawesome/pro-light-svg-icons/faTurnDownLeft';
import { faUnlock } from '@fortawesome/pro-light-svg-icons/faUnlock';
import { faUser } from '@fortawesome/pro-light-svg-icons/faUser';
import { faUserClock } from '@fortawesome/pro-light-svg-icons/faUserClock';
import { faUserGear } from '@fortawesome/pro-light-svg-icons/faUserGear';
import { faUserHardHat } from '@fortawesome/pro-light-svg-icons/faUserHardHat';
import { faUserMinus } from '@fortawesome/pro-light-svg-icons/faUserMinus';
import { faUserPen } from '@fortawesome/pro-light-svg-icons/faUserPen';
import { faUserPlus } from '@fortawesome/pro-light-svg-icons/faUserPlus';
import { faUserSlash } from '@fortawesome/pro-light-svg-icons/faUserSlash';
import { faUserTimes } from '@fortawesome/pro-light-svg-icons/faUserTimes';
import { faUsers } from '@fortawesome/pro-light-svg-icons/faUsers';
import { faUsersCog } from '@fortawesome/pro-light-svg-icons/faUsersCog';
import { faUsersMedical } from '@fortawesome/pro-light-svg-icons/faUsersMedical';
import { faVideoSlash } from '@fortawesome/pro-light-svg-icons/faVideoSlash';
import { faVolumeHigh } from '@fortawesome/pro-light-svg-icons/faVolumeHigh';
import { faVolumeSlash } from '@fortawesome/pro-light-svg-icons/faVolumeSlash';
import { faWrench } from '@fortawesome/pro-light-svg-icons/faWrench';
import { faXmarkLarge } from '@fortawesome/pro-light-svg-icons/faXmarkLarge';

import { faBriefcase as fasBriefcase } from '@fortawesome/pro-solid-svg-icons/faBriefcase';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck';
import { faCircleHalfStroke } from '@fortawesome/pro-solid-svg-icons/faCircleHalfStroke';
import { faEnvelopeCircleCheck } from '@fortawesome/pro-solid-svg-icons/faEnvelopeCircleCheck';
import { faFlagPennant as fasFlagPennant } from '@fortawesome/pro-solid-svg-icons/faFlagPennant';
import { faMoonStars as fasMoonStars } from '@fortawesome/pro-solid-svg-icons/faMoonStars';

import { faBriefcase as fadBriefcase } from '@fortawesome/pro-duotone-svg-icons/faBriefcase';
import { faIdCard as fadIdCard } from '@fortawesome/pro-duotone-svg-icons/faIdCard';

export {
  faArrowFromLeft,
  faArrowFromRight,
  faArrowLeft,
  faArrowLeftFromLine,
  faArrowRight,
  faArrowRightToLine,
  faArrowRotateLeft,
  faArrowToBottom,
  faArrowToLeft,
  faArrowToRight,
  faArrowUpRightFromSquare,
  faBarcodeRead,
  faBars,
  faBriefcase,
  faBullhorn,
  faBuilding,
  faBuildingColumns,
  faBusinessTime,
  faCalendar,
  faCalendarCheck,
  faCalendarDay,
  faCalendarDays,
  faCalendarXmark,
  faCcAmex,
  faCcDinersClub,
  faCcDiscover,
  faCcJcb,
  faCcMastercard,
  faCcVisa,
  faChartSimple,
  faCheck,
  faChevronLeft,
  faChevronRight,
  faCircleCheck,
  faCircleHalfStroke,
  faClock,
  faCog,
  faCommentAltPlus,
  faCommentMedical,
  faCompass,
  faConstruction,
  faCopy,
  faCreditCard,
  faCreditCardFront,
  faDatabase,
  faDebug,
  faDoorOpen,
  faDownload,
  faEdit,
  faEnvelope,
  faEnvelopeCircleCheck,
  faExclamationCircle,
  faExclamationTriangle,
  faExpand,
  faObjectGroup,
  faEye,
  faEyeSlash,
  faFileAlt,
  faFileChartLine,
  faFileCode,
  faFileExcel,
  faFileExport,
  faFileInvoiceDollar,
  faFilePdf,
  faFilePlus,
  faFileSignature,
  faFileVideo,
  faForward,
  faGaugeHigh,
  faGlobe,
  faGrid2,
  faHandsHoldingChild,
  faHardHat,
  faHelmetSafety,
  faHistory,
  faHourglassClock,
  faIdBadge,
  faIdCard,
  faIdCardClip,
  faInbox,
  faInfoCircle,
  faKey,
  faLandmark,
  faLanguage,
  faLightbulbOn,
  faLink,
  faListUl,
  faLock,
  faLockKeyhole,
  faMagic,
  faMagnet,
  faMagnifyingGlass,
  faMapLocationDot,
  faMapMarkerAlt,
  faMemo,
  faMinusOctagon,
  faMobile,
  faMobileSignal,
  faNewspaper,
  faPause,
  faPen,
  faPencil,
  faPhone,
  faPlay,
  faPlus,
  faPrint,
  faQrcode,
  faQuestion,
  faRedo,
  faRows,
  faSave,
  faSearch,
  faSend,
  faShieldCheck,
  faSignature,
  faSitemap,
  faSync,
  faTable,
  faTicket,
  faTimes,
  faTimer,
  faTools,
  faToolbox,
  faTruck,
  faTurnDownLeft,
  faTrash,
  faTrashAlt,
  faUnlock,
  faUser,
  faUserClock,
  faUserGear,
  faUserHardHat,
  faUserMinus,
  faUserPen,
  faUserPlus,
  faUserTimes,
  faUsersCog,
  faUsersMedical,
  faVideoSlash,
  faVolumeHigh,
  faVolumeSlash,
  faWrench,
  faXmarkLarge,
  fasMoonStars,
  fasFlagPennant,
  fadBriefcase,
  fadIdCard,
};

export const ArrowFromLeftIcon = getFaIcon({ icon: faArrowFromLeft });
export const ArrowFromRightIcon = getFaIcon({ icon: faArrowFromRight });
export const ArrowLeftIcon = getFaIcon({ icon: faArrowLeft });
export const ArrowLeftFromLineIcon = getFaIcon({ icon: faArrowLeftFromLine });
export const ArrowRightIcon = getFaIcon({ icon: faArrowRight });
export const ArrowRightToLineIcon = getFaIcon({ icon: faArrowRightToLine });
export const ArrowRotateLeftIcon = getFaIcon({ icon: faArrowRotateLeft });
export const ArrowToBottomIcon = getFaIcon({ icon: faArrowToBottom });
export const ArrowToLeftIcon = getFaIcon({ icon: faArrowToLeft });
export const ArrowToRightIcon = getFaIcon({ icon: faArrowToRight });
export const ArrowUpRightFromSquare = getFaIcon({
  icon: faArrowUpRightFromSquare,
});
export const BarcodeReadIcon = getFaIcon({ icon: faBarcodeRead });
export const BarsIcon = getFaIcon({ icon: faBars });
export const BriefcaseIcon = getFaIcon({ icon: faBriefcase });
export const BriefcaseSolidIcon = getFaIcon({ icon: fasBriefcase });
export const BullhornIcon = getFaIcon({ icon: faBullhorn });
export const BuildingColumnsIcon = getFaIcon({ icon: faBuildingColumns });
export const BuildingIcon = getFaIcon({ icon: faBuilding });
export const BusinessTimeIcon = getFaIcon({ icon: faBusinessTime });
export const CalendarDayIcon = getFaIcon({ icon: faCalendarDay });
export const CalendarDaysIcon = getFaIcon({ icon: faCalendarDays });
export const CalendarXmarkIcon = getFaIcon({ icon: faCalendarXmark });
export const CalendarCheckIcon = getFaIcon({ icon: faCalendarCheck });
export const CalendarIcon = getFaIcon({ icon: faCalendar });
export const CctvIcon = getFaIcon({ icon: faCctv });
export const ChartPieIcon = getFaIcon({ icon: faChartPie });
export const ChartSimpleIcon = getFaIcon({ icon: faChartSimple });
export const CheckIcon = getFaIcon({ icon: faCheck });
export const ChevronLeftIcon = getFaIcon({ icon: faChevronLeft });
export const ChevronRightIcon = getFaIcon({ icon: faChevronRight });
export const CircleCheckIcon = getFaIcon({ icon: faCircleCheck });
export const CircleHalfStrokeIcon = getFaIcon({ icon: faCircleHalfStroke });
export const ClipboardCheckIcon = getFaIcon({ icon: faClipboardCheck });
export const ClockIcon = getFaIcon({ icon: faClock });
export const CogIcon = getFaIcon({ icon: faCog });
export const CommentAltPlusIcon = getFaIcon({ icon: faCommentAltPlus });
export const CommentMedicalIcon = getFaIcon({ icon: faCommentMedical });
export const CompassIcon = getFaIcon({ icon: faCompass });
export const ConstructionIcon = getFaIcon({ icon: faConstruction });
export const CopyIcon = getFaIcon({ icon: faCopy });
export const CreditCardFrontIcon = getFaIcon({ icon: faCreditCardFront });
export const DataTableIcon = getFaIcon({ icon: faTable });
export const DatabaseIcon = getFaIcon({ icon: faDatabase });
export const DebugIcon = getFaIcon({ icon: faDebug });
export const DoorOpenIcon = getFaIcon({ icon: faDoorOpen });
export const DownloadIcon = getFaIcon({ icon: faDownload });
export const DroneIcon = getFaIcon({ icon: faDrone });
export const EditIcon = getFaIcon({ icon: faEdit });
export const EnvelopeIcon = getFaIcon({ icon: faEnvelope });
export const EnvelopeCircleCheckIcon = getFaIcon({
  icon: faEnvelopeCircleCheck,
});
export const ExclamationCircleIcon = getFaIcon({ icon: faExclamationCircle });
export const ExclamationTriangleIcon = getFaIcon({
  icon: faExclamationTriangle,
});
export const ExpandIcon = getFaIcon({ icon: faExpand });
export const ObjectGroupIcon = getFaIcon({ icon: faObjectGroup });
export const EyeIcon = getFaIcon({ icon: faEye });
export const EyeSlashIcon = getFaIcon({ icon: faEyeSlash });
export const FileAltIcon = getFaIcon({ icon: faFileAlt });
export const FileChartLineIcon = getFaIcon({ icon: faFileChartLine });
export const FileCodeIcon = getFaIcon({ icon: faFileCode });
export const FileExcelIcon = getFaIcon({ icon: faFileExcel });
export const FileExportIcon = getFaIcon({ icon: faFileExport });
export const FilePdfIcon = getFaIcon({ icon: faFilePdf });
export const FilePlusIcon = getFaIcon({ icon: faFilePlus });
export const FileSignatureIcon = getFaIcon({ icon: faFileSignature });
export const FileVideoIcon = getFaIcon({ icon: faFileVideo });
export const FlagPennantIcon = getFaIcon({ icon: fasFlagPennant });
export const ForwardIcon = getFaIcon({ icon: faForward });
export const GaugeHighIcon = getFaIcon({ icon: faGaugeHigh });
export const GlobeIcon = getFaIcon({ icon: faGlobe });
export const Grid2Icon = getFaIcon({ icon: faGrid2 });
export const HandsHoldingChildIcon = getFaIcon({ icon: faHandsHoldingChild });
export const HardHatIcon = getFaIcon({ icon: faHardHat });
export const HelmetSafetyIcon = getFaIcon({ icon: faHelmetSafety });
export const HistoryIcon = getFaIcon({ icon: faHistory });
export const HourglassClockIcon = getFaIcon({ icon: faHourglassClock });
export const IdBadgeIcon = getFaIcon({ icon: faIdBadge });
export const IdCardClipIcon = getFaIcon({ icon: faIdCardClip });
export const IdCardIcon = getFaIcon({ icon: faIdCard });
export const InboxIcon = getFaIcon({ icon: faInbox });
export const InfoCircleIcon = getFaIcon({ icon: faInfoCircle });
export const LanguageIcon = getFaIcon({ icon: faLanguage });
export const LandmarkIcon = getFaIcon({ icon: faLandmark });
export const LightbulbOnIcon = getFaIcon({ icon: faLightbulbOn });
export const LinkIcon = getFaIcon({ icon: faLink });
export const ListUlIcon = getFaIcon({ icon: faListUl });
export const LockIcon = getFaIcon({ icon: faLock });
export const LockKeyholeIcon = getFaIcon({ icon: faLockKeyhole });
export const MagicIcon = getFaIcon({ icon: faMagic });
export const MagnetIcon = getFaIcon({ icon: faMagnet });
export const MapLocationDotIcon = getFaIcon({ icon: faMapLocationDot });
export const MapMarkerAltIcon = getFaIcon({ icon: faMapMarkerAlt });
export const MapMarkerIcon = getFaIcon({ icon: faMapMarkerAlt });
export const MemoIcon = getFaIcon({ icon: faMemo });
export const MinusOctagonIcon = getFaIcon({ icon: faMinusOctagon });
export const MobileIcon = getFaIcon({ icon: faMobile });
export const MobileSignalIcon = getFaIcon({ icon: faMobileSignal });
export const MoonStarsSolidIcon = getFaIcon({ icon: fasMoonStars });
export const NewspaperIcon = getFaIcon({ icon: faNewspaper });
export const PauseIcon = getFaIcon({ icon: faPause });
export const PenIcon = getFaIcon({ icon: faPen });
export const PencilIcon = getFaIcon({ icon: faPencil });
export const PhoneIcon = getFaIcon({ icon: faPhone });
export const PlayIcon = getFaIcon({ icon: faPlay });
export const PlusIcon = getFaIcon({ icon: faPlus });
export const PreviewIcon = getFaIcon({ icon: faMagnifyingGlass });
export const PrintIcon = getFaIcon({ icon: faPrint });
export const QrcodeIcon = getFaIcon({ icon: faQrcode });
export const QuestionIcon = getFaIcon({ icon: faQuestion });
export const RedoIcon = getFaIcon({ icon: faRedo });
export const RowsIcon = getFaIcon({ icon: faRows });
export const SaveIcon = getFaIcon({ icon: faSave });
export const SearchIcon = getFaIcon({ icon: faSearch });
export const SendIcon = getFaIcon({ icon: faSend });
export const ShieldCheckIcon = getFaIcon({ icon: faShieldCheck });
export const SignatureIcon = getFaIcon({ icon: faSignature });
export const SitemapIcon = getFaIcon({ icon: faSitemap });
export const StethoscopeIcon = getFaIcon({ icon: faStethoscope });
export const TableIcon = getFaIcon({ icon: faTable });
export const TicketIcon = getFaIcon({ icon: faTicket });
export const TimesIcon = getFaIcon({ icon: faTimes });
export const TimerIcon = getFaIcon({ icon: faTimer });
export const ToolsIcon = getFaIcon({ icon: faTools });
export const ToolboxIcon = getFaIcon({ icon: faToolbox });
export const TruckIcon = getFaIcon({ icon: faTruck });
export const TurnDownLeftIcon = getFaIcon({ icon: faTurnDownLeft });
export const TrashAltIcon = getFaIcon({ icon: faTrashAlt });
export const TrashIcon = getFaIcon({ icon: faTrash });
export const UnlockIcon = getFaIcon({ icon: faUnlock });
export const UserClockIcon = getFaIcon({ icon: faUserClock });
export const UserHardHatIcon = getFaIcon({ icon: faUserHardHat });
export const UserIcon = getFaIcon({ icon: faUser });
export const UserMinusIcon = getFaIcon({ icon: faUserMinus });
export const UserPenIcon = getFaIcon({ icon: faUserPen });
export const UserPlusIcon = getFaIcon({ icon: faUserPlus });
export const UserSlashIcon = getFaIcon({ icon: faUserSlash });
export const UserTimesIcon = getFaIcon({ icon: faUserTimes });
export const UsersCogIcon = getFaIcon({ icon: faUsersCog });
export const UsersIcon = getFaIcon({ icon: faUsers });
export const UsersMedicalIcon = getFaIcon({ icon: faUsersMedical });
export const VideoSlashIcon = getFaIcon({ icon: faVideoSlash });
export const VolumeHighIcon = getFaIcon({ icon: faVolumeHigh });
export const VolumeSlashIcon = getFaIcon({ icon: faVolumeSlash });
export const WrenchIcon = getFaIcon({ icon: faWrench });
export const XMarkLargeIcon = getFaIcon({ icon: faXmarkLarge });

export const BriefcaseDuotoneIcon = getFaIcon({ icon: fadBriefcase });
export const IdCardDuotoneIcon = getFaIcon({ icon: fadIdCard });
